<template>
    <div class="module">
        <div class="content">
            <IfmSubHeader title="IFM活动"/>
            <div class="main">
                <div class="left">
                    <NewsModule :arr="activityList" />
                </div>
                <div class="right">
                    <Shipintupian />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NewsModule from './newsModule.vue';
import Shipintupian from './shipintupian.vue';

export default {
    props:{
        activityList:{
            type:Array,
            default: () => [],
        }
    },
    components:{
        NewsModule,
        Shipintupian
    },
    methods: {
        goDetail(id){
            this.$router.push(`/activityDetail?id=${id}`);
        }
    },
}
</script>
<style lang="scss" scoped>
.module{
    background: #F0F0F0;
    padding: 25px 0 39px 0;
    .content{
        width: 1120px;
        margin: auto;
    }
}
.main{
    width: 100%;
    background: #ffffff;
    margin-top: 28px;
    display: flex;
    .left{
        padding: 0px;
        box-sizing: border-box;
        width:682px;
        div{
            width:100%;
        }
        img{
            height:140px;
            width: 100%;
        }
        .title{
            margin-bottom: 13px;
            font-size: 24px;
            color: #333333;
            letter-spacing: 0.68px;
            font-weight: 600;
        }
        .info{
            font-size: 14px;
            color: #333333;
            letter-spacing: 0.4px;
            font-weight: 400;
            margin-bottom: 30px;
            display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
        }
    }
    .line{
        width:1px;
        background: #F0F0F0;
        height: auto;
    }
    .right{
        flex: 1;
        box-sizing: border-box;
        .single-act{
            width:100%;
            margin-bottom: 54px;
            div{
                width:100%;
            }
            .title{
                font-size: 16px;
                color: #333333;
                letter-spacing: 0.45px;
                font-weight: 600;
                margin-bottom: 16px;
            }
            .info{
                font-size: 14px;
                color: #333333;
                letter-spacing: 0.4px;
                font-weight: 400;
                display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 3;
overflow: hidden;
            }
        }
    }
}

</style>
